"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnRejectAction = exports.KeywordDetectionType = void 0;
/**
 * Represents the type of keyword detection.
 */
var KeywordDetectionType;
(function (KeywordDetectionType) {
    /**
     * Triggered at the start of input.
     */
    KeywordDetectionType["StartTrigger"] = "StartTrigger";
})(KeywordDetectionType = exports.KeywordDetectionType || (exports.KeywordDetectionType = {}));
/**
 * The action to take when a keyword is rejected.
 */
var OnRejectAction;
(function (OnRejectAction) {
    /**
     * End the current turn.
     */
    OnRejectAction["EndOfTurn"] = "EndOfTurn";
    /**
     * Continue processing.
     */
    OnRejectAction["Continue"] = "Continue";
})(OnRejectAction = exports.OnRejectAction || (exports.OnRejectAction = {}));

//# sourceMappingURL=KeywordDetection.js.map
